"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sites_1 = require("@/services/sites");
const evaluators_1 = require("@/store/ducks/evaluators");
const constants_1 = require("./constants");
function listSiteTabs() {
    return (dispatch) => {
        dispatch((0, evaluators_1.getTabs)());
        (0, sites_1.getSites)()
            .then((sites) => {
            const sitesTabs = sites.map((site) => {
                return {
                    name: site.name,
                    id: site.id,
                };
            });
            dispatch((0, evaluators_1.fillTabs)(sitesTabs));
        })
            .catch(() => {
            dispatch((0, evaluators_1.fillTabs)(constants_1.DEFAULT_SITES));
        });
    };
}
exports.default = listSiteTabs;
